export { default as website } from './website.png';
export { default as setup } from './setup.png';
export { default as arrow } from './arrow_outward (1).png';
export { default as tick } from './tick.png';
export { default as buildImg } from './build.png';
export { default as pluginImg } from './plugin.png';
export { default as updateImg } from './update.png';
export { default as backupImg } from './backup.png';
export { default as restoredImg } from './restored.png';
export { default as adminAccountsImg } from './adminAccounts.png';
export { default as codeOrAppImg } from './codeOrApp.png';
export { default as wouldRespondImg } from './wouldRespond.png';
export { default as contentUpdateImg } from './contentUpdate.png';
export { default as networksImg } from './networks.png';
export { default as questionResult } from './questionResult.png';
export { default as scanPrcoessing } from './scanProcessing.png';
export { default as checkWeb } from './image 583042 [Vectorized] (1).png';
export { default as offical } from './official.png';
export { default as needAction } from './needaction.png';
export { default as needImprovement } from './needimprovement.png';